var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLookProfessionalBusiness = function SvgLookProfessionalBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3Zm1 0h6V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1Zm10 1H1v3h3V6h1v1h6V6h1v1h3V4ZM1 8v5h14V8h-3v1h-1V8H5v1H4V8H1Z",
    fill: "#162D3D"
  })));
};
export default SvgLookProfessionalBusiness;